<template>
  <div class="portfolio">
    <div class="alert-option">
      <label>
      <input type="checkbox" v-model="user.email_alerts" id="email_alerts" />
      Alert me of changes in my folders
      </label>
    </div>
    <div class="main-item" v-for="(folders, mainname) in portfolio" :key="mainname">
      <h5>{{ mainname }}</h5>
      <div class="folder" v-for="folder in folders" :key="folder.id">
        <router-link :to="`/${folder.id}`">
          <img src="../assets/small-folder.png" alt="folder icon">
          {{ folder.display_name }}
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import {mapState} from 'vuex'

export default {
  name: 'Portfolio',
  computed: {
    ...mapState(['user']),
  },
  data() {
    return {
      portfolio: [],
      alertStatus: false,
    }
  },
  watch: {
    ['user.email_alerts'](value) {

      if (value !== undefined && value !== null) {
        this.updateAlertStatus(value)
      }
    },
  },
  methods: {
    async updateAlertStatus(status) {
      let r = await axios.patch(`/api/users/${this.user.id}`, {'email_alerts': status})

      if (r.status != 200) {
        return;
      }

      this.$store.dispatch('setEmailAlertStatus', status)

      // this.user.email_alerts = this.alertStatus
    },
    async getFolders() {
      let r = await axios.get('/api/files/portfolio')

      if (r.status != 200) {
        return;
      }

      this.portfolio = r.data.portfolio
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.alertStatus = this.user.email_alerts
    //   console.log('alerts?', this.user.email_alerts)
    // })
  },
  created() {
    this.getFolders()
  }
}
</script>
<style lang="scss">
.portfolio {
  .alert-option {
    margin: 1rem 0;
  }
  .main-item {
    margin: 1.5rem 0 0 0.75rem;
    h5 {
      font-size: 1.15rem;
    }

    .folder {
      margin: 0.75rem 0 0.5rem 0.5rem;
      a {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;

        img {
          width: 25px;
          height: auto;
          display: inline-block;
          margin: 0 0.5rem 0 0;
        }
        font-size: 0.875rem;
        color: #222;
        text-decoration: none;
      }
    }
  }
}
</style>
